import assistentAvatar from "../../assets/img/assistent-avatar.png";
import "./header.css";
import Marquee from 'react-fast-marquee';

export const SlideHeader = () => {

  return (
      <div className="main-header">
        <div className="top-banner">
          <Marquee speed={40}>

            <div style={{marginTop:"3px", display: 'flex', marginRight: "50px"}}>
              <a href="https://t.me/fix_auto_md_bot" target="_blank" className="banner-data">
                <img src={assistentAvatar} alt="" width={"38px"}/>
                <p className="plce">FixAuto - Asistent</p>
              </a>
            </div>

            <div style={{marginTop:"3px", marginRight: "50px"}}>
              <a href="https://t.me/fix_auto_md_bot" target="_blank" className="banner-data">
                <img src={assistentAvatar} alt="" width={"38px"}/>
                <p className="plce">FixAuto - Asistent</p>
              </a>
            </div>


            <div style={{marginTop:"3px", display: 'flex', marginRight: "50px"}}>
              <a href="https://t.me/fix_auto_md_bot" target="_blank" className="banner-data">
                <img src={assistentAvatar} alt="" width={"38px"}/>
                <p className="plce">FixAuto - Asistent</p>
              </a>
            </div>

            <div style={{marginTop:"3px", marginRight: "50px"}}>
              <a href="https://t.me/fix_auto_md_bot" target="_blank" className="banner-data">
                <img src={assistentAvatar} alt="" width={"38px"}/>
                <p className="plce">FixAuto - Asistent</p>
              </a>
            </div>



            <div style={{marginTop:"3px", display: 'flex', marginRight: "50px"}}>
              <a href="https://t.me/fix_auto_md_bot" target="_blank" className="banner-data">
                <img src={assistentAvatar} alt="" width={"38px"}/>
                <p className="plce">FixAuto - Asistent</p>
              </a>
            </div>

            <div style={{marginTop:"3px", marginRight: "50px"}}>
              <a href="https://t.me/fix_auto_md_bot" target="_blank" className="banner-data">
                <img src={assistentAvatar} alt="" width={"38px"}/>
                <p className="plce">FixAuto - Asistent</p>
              </a>
            </div>


            <div style={{marginTop:"3px", display: 'flex', marginRight: "50px"}}>
              <a href="https://t.me/fix_auto_md_bot" target="_blank" className="banner-data">
                <img src={assistentAvatar} alt="" width={"38px"}/>
                <p className="plce">FixAuto - Asistent</p>
              </a>
            </div>

            <div style={{marginTop:"3px", marginRight: "50px"}}>
              <a href="https://t.me/fix_auto_md_bot" target="_blank" className="banner-data">
                <img src={assistentAvatar} alt="" width={"38px"}/>
                <p className="plce">FixAuto - Asistent</p>
              </a>
            </div>


          </Marquee>

          </div>

        {/*<div className="nav-bar">*/}
        {/*  <div className="max-width inner-bar">*/}
        {/*    <Link to="/" className="flexb">*/}
        {/*      <img src={logo_fixauto} alt="" />*/}
        {/*    </Link>*/}
        {/*  </div>*/}
        {/*</div>*/}
      </div>
  );
};
